module.exports = __webpack_public_path__ + "41f9c7ad8ec7b17d5f1fc97c0b574c6b.svg";